export default __webpack_public_path__ + "5959e41c5addb399182e43e732543ef1.png";